var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"d-flex flex-column h-100 strategy-container text-center"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"strategy-title"},[_c('span',{staticClass:"line line-1"},[_vm._v("Building a Sustainable")]),_c('br'),_c('span',{staticClass:"line line-2"},[_vm._v(" Future Together ")])])
}]

export { render, staticRenderFns }